import { createStore } from 'vuex'
import getters from './getters'

export default createStore({
  state: {
  	guideTheme: {
  		color: '#4A646C',
  		title: '语音讲解'
  	}
  },
  getters,
  strict: false
})
